import {useQuery} from "react-query";
import { queryKey } from "@/store/queryKeys";
import { constants } from "@/constants";
import Logger from "@/utils/logger";
import {ChatSettings, mapChatbot} from "@/models/chatbot.ts";
import {camelToSnakeObj} from "@/utils/utils.ts";
import {toast} from "react-toastify";

let lastAlert = "";
export const chatbotSettingsQuery = (token: string, session: string, baseURL? : string) => {
  let origin = "";
  try {
    origin = window.parent ? window.parent.origin : window.location.origin;
  } catch (e) {
    origin = document.referrer;
  }

  return useQuery({
    queryKey: queryKey.chatbotInterfaceSettings,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      let res = await fetch(
        `${baseURL ? baseURL : constants.url.API_PREFIX}chat/settings?token=${token}&session=${session}&parent=${origin}`,
      );
      if (!res.ok) {
        try {
          let json = await res.json();
          if (
            json.error.includes("current domain") &&
            lastAlert != json.error
          ) {
            lastAlert = json.error;
            alert(json.error);
          }
        } catch (e) {}
        Logger.error("WIZYCHAT : can't load settings. Please check your token");
        return null;
      } else {
        return res.json();
      }
    },
  });
};

export const chatbotListQuery = () => {
  return useQuery({
    queryKey: queryKey.chatbotList,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return fetch(`${constants.url.API_PREFIX}chatbot/list`).then(async (response) => {
        let data = await response.json()

        return data.map((item : any) => {
          return mapChatbot(item)
        })
    });
    },
  });
};

export const catalogFetch = async () => {
  return fetch(`${constants.url.API_PREFIX}chatbot/catalog`).then(async (response) => {
    return await response.json()
  });
};

export const catalogQuery = () => {
  return useQuery({
    queryKey: queryKey.catalog,
    refetchOnWindowFocus: false,
    queryFn: catalogFetch,
  });
};

export async function saveSettings (chatbotID : string | undefined, settings : ChatSettings, onSaved : () => void) {
  if (!chatbotID) {
    toast.error("Chatbot is not set", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
  }

  const formData = new FormData();
  let snaked = camelToSnakeObj(settings);
  formData.append("settings", JSON.stringify(snaked));

  try {
    let res = await fetch(
      `${constants.url.API_PREFIX}chatbot/${chatbotID}/settings`,
      {
        method: "POST",
        body: formData,
      },
    );
    let json = await res.json();
    if (json.error) {
      toast.error(json.error, {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } else if (json.message) {
      toast.success(json.message, {
        position: "top-right",
        autoClose: 1500,
        theme: "light",
      });
    }
  } catch (e) {
    toast.error("Upload error", {
      position: "top-right",
      autoClose: 1500,
      theme: "light",
    });
  } finally {
    onSaved()
  }
};